import ClientsAxios from '../client-axios';
import { handlePostRequest } from './requestHandler';

const { COMMUNITY_HEALTH_CAMP_SERVER } = ClientsAxios;

export const FetchCityListService = (payload: any) =>
    handlePostRequest<any>('hospital/city', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchServicesListService = (payload: any) =>
    handlePostRequest<any>('hospital/services-list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchPreHospitalListService = (payload: any) =>
    handlePostRequest<any>('hospital/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchHospitalDetailsDataService = (payload: any, Key: boolean) =>
    handlePostRequest<any>(
        Key ? 'hospital/details' : 'hospital/approved-details',
        payload,
        COMMUNITY_HEALTH_CAMP_SERVER
    );

export const GetDieasesListService = (payload: any) =>
    handlePostRequest<any>('diseases/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);
